import { Container } from "react-bootstrap";
import "./EventPageHeader.scss";

function EventPageHeader({ eventName, eventDate, onClick }) {
  return (
    <Container>
      <header
        className="event-page-header text-center"
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : "default" }}
      >
        <h1 className="event-title">{eventName}</h1>
        <div className="event-details">
          <p className="event-date mb-0">{eventDate}</p>
          {onClick && <small className="text-muted mt-1 d-block">ℹ️</small>}
        </div>
      </header>
    </Container>
  );
}

export default EventPageHeader;
